module.exports = __webpack_public_path__ + "img/specials-slider-v-luxury.067e8786.png";